import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiGrid } from 'react-icons/fi'
import {
  Label,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { useSelector } from 'react-redux'
import { IStore } from '../../../../../reducers'
import { withRouter } from 'react-router'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import Flex from 'typescript-styled-flex'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function Widgets({ history, size = 1, badge = false }: any) {
  const [isOpen, toggleOpen] = React.useState(false)
  // const { t } = useTranslation()
  const isSidebarOpen = useSelector(
    (state: IStore) => state.bookingCalendar.isSidebarOpen,
  )

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  const planScope = useLicensePlansScope()
  const userId = useSelector(getUserId)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)

  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      handlePopoverOpen(event)
    }
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   if (isSidebarOpen) {
  //     setTimeout(() => {
  //       setPopoverAnchor(target)
  //     }, 10)
  //   }
  // }

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Widget Menu Opened', 1)
    Mixpanel.track('Main Menu Widget Item Used', {})
  }

  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Payments Methods Menu Opened', 1)
    Mixpanel.track('Payments Methods Menu Item Used', {})
  }

  const trackClick3 = () => {
    Mixpanel.people.increment(userId, 'Amenities Menu Opened', 1)
    Mixpanel.track('Amenities Menu Item Used', {})
  }
  const trackClick4 = () => {
    Mixpanel.people.increment(userId, 'Licence Number Menu Opened', 1)
    Mixpanel.track('Licence Number Menu Item Used', {})
  }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          nested={true}
        >
          <b>
            <FiGrid size={16 * size} />
          </b>
          <Label primary={true} size={size}>
            <Trans i18nKey={'BBO_2891_menu_booking_engine'}>
              System rezerwacji
            </Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList
            nested={true}
            size={size}
            style={{ maxHeight: 'var(--full)' }}
          >
            <SmartLink
              exact={true}
              onClick={e => {
                trackClick()
                handleLinkClick(e, PlansScope.ReservationSystemConfig)
              }}
              size={size}
              to={isInPlanScopeRedirect(
                planScope,
                PlansScope.ReservationSystemConfig,
                '/widgets',
                userPriceGroup,
              )}
              activeClassName={'active'}
              nested={true}
            >
              <MenuElement
                size={size}
                alignCenter
                // onMouseEnter={
                //   !isMobile &&
                //   isInPlanScope(
                //     planScope,
                //     PlansScope.PaymentMethods,
                //     userPriceGroup,
                //   )
                //     ? handleMouseEnter
                //     : undefined
                // }
              >
                <Flex alignCenter full>
                  <Trans i18nKey="configuration">Konfiguracja</Trans>
                  {isInPlanScope(
                    planScope,
                    PlansScope.ReservationSystemConfig,
                    userPriceGroup,
                  ) && (
                    <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
                      <PopoveredIcon2 />
                    </Flex>
                  )}
                </Flex>
              </MenuElement>
            </SmartLink>
            <SmartLink
              onClick={e => {
                trackClick2()
                handleLinkClick(e, PlansScope.PaymentMethods)
              }}
              size={size}
              to={isInPlanScopeRedirect(
                planScope,
                PlansScope.PaymentMethods,
                '/price/method',
                userPriceGroup,
              )}
              activeClassName={'active'}
              nested={true}
            >
              <MenuElement
                size={size}
                alignCenter
                // onMouseEnter={
                //   !isMobile &&
                //   isInPlanScope(
                //     planScope,
                //     PlansScope.PaymentMethods,
                //     userPriceGroup,
                //   )
                //     ? handleMouseEnter
                //     : undefined
                // }
              >
                <Flex alignCenter full>
                  <Trans i18nKey="BED_5422_payment_methods">
                    Metody płatności
                  </Trans>
                  {isInPlanScope(
                    planScope,
                    PlansScope.PaymentMethods,
                    userPriceGroup,
                  ) && (
                    <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
                      <PopoveredIcon2 />
                    </Flex>
                  )}
                </Flex>
              </MenuElement>
            </SmartLink>
            <SmartLink
              size={size}
              to={isInPlanScopeRedirect(
                planScope,
                PlansScope.Amenities,
                '/offer/facilities',
                userPriceGroup,
              )}
              activeClassName={'active'}
              nested={true}
              onClick={e => {
                trackClick3()
                handleLinkClick(e, PlansScope.Amenities)
              }}
            >
              <MenuElement
                size={size}
                alignCenter
                // onMouseEnter={
                //   !isMobile &&
                //   isInPlanScope(planScope, PlansScope.Amenities, userPriceGroup)
                //     ? handleMouseEnter
                //     : undefined
                // }
              >
                <Flex alignCenter full>
                  <Trans i18nKey="BBO_3139_facilities">Udogodnienia</Trans>
                  {isInPlanScope(
                    planScope,
                    PlansScope.Amenities,
                    userPriceGroup,
                  ) && (
                    <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
                      <PopoveredIcon2 />
                    </Flex>
                  )}
                </Flex>
              </MenuElement>
            </SmartLink>
            <SmartLink
              size={size}
              to={isInPlanScopeRedirect(
                planScope,
                PlansScope.Notifications,
                '/booking/notifications',
                userPriceGroup,
              )}
              activeClassName={'active'}
              nested={true}
              onClick={e => {
                handleLinkClick(e, PlansScope.Notifications)
              }}
            >
              <MenuElement
                size={size}
                alignCenter
                // onMouseEnter={
                //   !isMobile &&
                //   isInPlanScope(
                //     planScope,
                //     PlansScope.Notifications,
                //     userPriceGroup,
                //   )
                //     ? handleMouseEnter
                //     : undefined
                // }
              >
                <Flex alignCenter full>
                  <Trans i18nKey="room_notification_title">Powiadomienia</Trans>
                  {isInPlanScope(
                    planScope,
                    PlansScope.Notifications,
                    userPriceGroup,
                  ) && (
                    <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
                      <PopoveredIcon2 />
                    </Flex>
                  )}
                </Flex>
              </MenuElement>
            </SmartLink>
            <SmartLink
              exact={true}
              onClick={e => {
                trackClick4()
                handleLinkClick(e, PlansScope.LicenseNumber)
              }}
              size={size}
              to={isInPlanScopeRedirect(
                planScope,
                PlansScope.LicenseNumber,
                '/widgets/license',
                userPriceGroup,
              )}
              activeClassName={'active'}
              nested={true}
            >
              <MenuElement
                size={size}
                alignCenter
                // onMouseEnter={
                //   !isMobile &&
                //   isInPlanScope(
                //     planScope,
                //     PlansScope.LicenseNumber,
                //     userPriceGroup,
                //   )
                //     ? handleMouseEnter
                //     : undefined
                // }
              >
                <Flex alignCenter full>
                  <Trans i18nKey="OUT_5032_licence_number">Numer licencji</Trans>
                  {isInPlanScope(
                    planScope,
                    PlansScope.LicenseNumber,
                    userPriceGroup,
                  ) && (
                    <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
                      <PopoveredIcon2 />
                    </Flex>
                  )}
                </Flex>
              </MenuElement>
            </SmartLink>
          </MenuList>
        )}
      </MenuElement>
      <Flex style={{ marginLeft: 'auto' }} alignCenter justifyEnd>
        <PopoveredIcon2
          withIcon={false}
          anchorEl={popoverAnchor}
          onOpen={handlePopoverOpen}
          onClose={handlePopoverClose}
        />
      </Flex>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default withRouter(Widgets as any) as any
